import { Link } from 'react-router-dom';
import styles from './Category.module.scss';

const Category = (props)=>{

    return(
        <Link 
            to={`/product-list/${props.data.id}`} 
            id={props.data.id} 
            className={`${styles.categoryBox} text-decoration-none`}
            >
            {/* <div className={styles.coverImage} style={{backgroundImage: `url("${props.listData.img}")`}} /> */}
            <img className={styles.coverImage} src={`${!props.data.image ? 'images.png' : `${process.env.REACT_APP_API_URL}${props.data.image}`}`} />
            <div  className={` text-center p-3`}>
                <div className={`py-1 ${styles.title}`}>{props.data.title}</div>
            </div>
        </Link>
    )
}

export default Category;